import { SendBuy } from '../../services/SendBuy';
import './Resume.css';
import '../cart/Carro.css';
import { useShopingCart } from '../../hooks/useShopingCart';
import ComprasAnteriores from '../purchases/comprasAnteriores';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../auth/context/UserContext';
import { useNavigate } from 'react-router-dom';
import { useClient } from '../../../catalogo/hooks/useClient';
import { ResumeCard } from '../resumeCard/ResumeCard';
import { useGlobalStore } from '../../../../Hooks/useGlobalStore';
import Cookies from 'universal-cookie';

export const Resume = () => {
  const { clearItems, clearShopingCart } = useShopingCart();
  const { dataUser } = useContext(UserContext);
  const [observaciones, setObservaciones] = useState('');
  const { data: storedObservaciones } = useGlobalStore('Observaciones');

  const { clearClient } = useClient();

  const navigate = useNavigate();

  const cookies = new Cookies();
  const grupos = cookies.get('grupos');

  const eliminarItemDelCarrito = () => {
    clearItems();
    clearClient();
    if (grupos && grupos.length > 0) {
      navigate(
        `/catalog/catalogo?grupos=${encodeURIComponent(grupos.join(','))}`
      );
    } else {
      navigate('/catalog/catalogo');
    }
    clearShopingCart();
  };

  useEffect(() => {
    if (storedObservaciones) {
      setObservaciones(storedObservaciones);
    }
  }, [storedObservaciones]);

  return (
    <div className="cardResume">
      <article className="contenedorCardTotal sticky-footer">
        <header className="header-left">
          <strong>Resumen del Comprobante</strong>
          <hr />
        </header>

        <ResumeCard
          onObservacionesChange={(value) => {
            setObservaciones(value);
          }}
        />
        <hr className="lineaTotal" />
        <section className="contenedorBtnTot">
          <button
            className="transparent"
            type="button"
            onClick={eliminarItemDelCarrito}
          >
            Cancelar
          </button>
          <SendBuy user={dataUser.id} observaciones={observaciones} />
        </section>
      </article>
      <ComprasAnteriores titulo="Compras Anteriores" />
    </div>
  );
};
